import type { Dates } from '@/app/components/search/utils';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import type { IntlDateTimeFormatOptions } from '@/app/components/hotel-detail/common/dates.ts';
import { formatDate } from '@/app/components/hotel-detail/common/dates.ts';
import BasicModalHeader from '@/app/components/search/components/Modal/LayoutElements/BasicModalHeader';
import { TabItem, TabsContainer } from '@/app/common/components/Modals/CustomCalendar/CustomDatePickerHeader/styled.ts';

export function CustomDatePickerHeader({
  dates,
  returnDateWasPreselected,
}: {
  dates: Dates | undefined;
  returnDateWasPreselected?: boolean;
}) {
  const { localization } = usePageWrapperData();
  const { locale } = localization;
  const { isMobile } = useCommonClient();
  const { t } = useTranslation();
  const departureDate = dates?.departureDate?.date;
  const returnDate = dates?.returnDate?.date;
  const formatOptions: IntlDateTimeFormatOptions = { weekday: 'short', day: 'numeric', month: 'short' };
  const formattedDeparture = departureDate ? formatDate(locale, new Date(departureDate), formatOptions) : undefined;
  const formattedReturn = returnDate
    ? formatDate(locale, new Date(returnDate as string), formatOptions)
    : t('vacation.oss.header.widget.calendar.select_return');

  const isReturnSelected = !!(departureDate && returnDateWasPreselected);
  const isDepartureSelected = !isReturnSelected;

  return (
    <BasicModalHeader
      removeShadow={isMobile}
      style={isMobile ? {} : { height: 64 }}
      className="custom-date-picker-inner-header-mobile"
    >
      <TabsContainer isMobile={isMobile}>
        {departureDate && (
          <TabItem isSelected={isDepartureSelected} isMobile={isMobile}>
            {formattedDeparture}
          </TabItem>
        )}
        <>
          <TabItem isMobile={isMobile}> – </TabItem>
          <TabItem isSelected={isReturnSelected} isMobile={isMobile}>
            {formattedReturn}
          </TabItem>
        </>
      </TabsContainer>
    </BasicModalHeader>
  );
}
